import { useLicencia } from '../context/LicenciaContext';

export const MONEDAS = [
  { codigo: 'COP', nombre: 'Peso Colombiano', pais: 'Colombia', locale: 'es-CO', decimales: 0, codigoTelefono: '57' },
  { codigo: 'PYG', nombre: 'Guaraní', pais: 'Paraguay', locale: 'es-PY', decimales: 0, codigoTelefono: '595' },
  { codigo: 'ARS', nombre: 'Peso Argentino', pais: 'Argentina', locale: 'es-AR', decimales: 0, codigoTelefono: '54' },
  { codigo: 'CLP', nombre: 'Peso Chileno', pais: 'Chile', locale: 'es-CL', decimales: 0, codigoTelefono: '56' },
  { codigo: 'CRC', nombre: 'Colón', pais: 'Costa Rica', locale: 'es-CR', decimales: 0, codigoTelefono: '506' },
  { codigo: 'MXN', nombre: 'Peso Mexicano', pais: 'México', locale: 'es-MX', decimales: 2, codigoTelefono: '52' },
  { codigo: 'PEN', nombre: 'Sol', pais: 'Perú', locale: 'es-PE', decimales: 2, codigoTelefono: '51' },
  { codigo: 'BOB', nombre: 'Boliviano', pais: 'Bolivia', locale: 'es-BO', decimales: 2, codigoTelefono: '591' },
  { codigo: 'UYU', nombre: 'Peso Uruguayo', pais: 'Uruguay', locale: 'es-UY', decimales: 2, codigoTelefono: '598' },
  { codigo: 'BRL', nombre: 'Real Brasileño', pais: 'Brasil', locale: 'pt-BR', decimales: 2, codigoTelefono: '55' },
  { codigo: 'DOP', nombre: 'Peso Dominicano', pais: 'Rep. Dominicana', locale: 'es-DO', decimales: 2, codigoTelefono: '1' },
  { codigo: 'GTQ', nombre: 'Quetzal', pais: 'Guatemala', locale: 'es-GT', decimales: 2, codigoTelefono: '502' },
  { codigo: 'HNL', nombre: 'Lempira', pais: 'Honduras', locale: 'es-HN', decimales: 2, codigoTelefono: '504' },
  { codigo: 'NIO', nombre: 'Córdoba', pais: 'Nicaragua', locale: 'es-NI', decimales: 2, codigoTelefono: '505' },
  { codigo: 'VES', nombre: 'Bolívar Soberano', pais: 'Venezuela', locale: 'es-VE', decimales: 2, codigoTelefono: '58' },
  { codigo: 'USD', nombre: 'Dólar Estadounidense', pais: 'Internacional', locale: 'en-US', decimales: 2, codigoTelefono: '57' },
];

function formatearMonto(monto, codigoMoneda = 'COP') {
  const m = MONEDAS.find(m => m.codigo === codigoMoneda) || MONEDAS[0];
  return new Intl.NumberFormat(m.locale, {
    style: 'currency',
    currency: m.codigo,
    minimumFractionDigits: m.decimales,
    maximumFractionDigits: m.decimales,
  }).format(monto || 0);
}

/** Devuelve una función `formatMoneda(monto)` que formatea usando la moneda configurada de la empresa. */
export function useFormatMoneda() {
  const { moneda } = useLicencia();
  return (monto) => formatearMonto(monto, moneda);
}

/**
 * Devuelve una función `numeroWhatsApp(telefono)` que arma el número en
 * formato internacional (código de país + número) para usar en links
 * `https://wa.me/...`. Usa el código de área que haya configurado la
 * empresa en Configuración; si no hay ninguno, lo deriva de la moneda.
 * Evita anteponer el código si el teléfono ya lo trae.
 */
export function useWhatsAppNumero() {
  const { moneda, codigoArea } = useLicencia();
  const m = MONEDAS.find(m => m.codigo === moneda) || MONEDAS[0];
  const codigo = codigoArea || m.codigoTelefono;
  return (telefono) => {
    const digitos = (telefono || '').replace(/\D/g, '');
    if (digitos.startsWith(codigo) && digitos.length > codigo.length + 6) return digitos;
    return `${codigo}${digitos}`;
  };
}
